import baseService from './baseService.js';

export function getJobLocationsList(organization_id) {
    return baseService.get(`organizations/${organization_id}/jobs/new`);
}
